import { render, staticRenderFns } from "./SessionFrame.vue?vue&type=template&id=7ab50258&"
import script from "./SessionFrame.vue?vue&type=script&lang=js&"
export * from "./SessionFrame.vue?vue&type=script&lang=js&"
import style0 from "./SessionFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports